import axios from "axios";
import { decryptToken } from "./Account/EncryptionToken";

let apiClient;
let ssoOrManager=window.location.href.includes("manager")?true:false;
const loadConfig = async () => {
  try {
    // const response = await fetch("/grants/Helpers/main.json");
    // const response = await fetch("/Helpers/main.json");
    const response = await fetch(` ${window.location.origin}/grants/Helpers/main.json`);

    const config = await response.json();

    return config;
  } catch (error) {
    console.error("Error loading config:", error);
    throw error;
  }
};

// تجديد Access Token باستخدام Refresh Token
const refreshAccessToken = async () => {
  const config = await loadConfig();

  const refreshToken =ssoOrManager? sessionStorage.getItem("RefreshtokenManager"): sessionStorage.getItem("Refreshtoken");
  try {
    const response = await axios.post(
      `${config.domainUrl}/api/Account/RefreshToken`,
      { token: refreshToken }
    );
    const { accessToken } = response.data.result.token;
    const { refreshToken } = response.data.result.refreshToken;
    if(ssoOrManager){
      sessionStorage.setItem("AccessTokenManager", accessToken);
      sessionStorage.setItem("RefreshtokenManager", refreshToken);
    }else{

      sessionStorage.setItem("AccessToken", accessToken);
      sessionStorage.setItem("Refreshtoken", refreshToken);
    }
    return accessToken;
  } catch (error) {
    console.error("Error refreshing token:", error);
    window.location.href = "/login"; // إعادة توجيه إلى صفحة تسجيل الدخول في حال فشل التجديد
    return null;
  }
};

export const initializeApiClient = async (ContentType) => {
  const token = ssoOrManager?decryptToken("AccessTokenManager","manager"):decryptToken("AccessToken","sso");
  

  const config = await loadConfig();
  apiClient = axios.create({
    baseURL: config.domainUrl, // استخدام baseURL من ملف JSON
    timeout: 900000,
  });

  // إضافة interceptors
  apiClient.interceptors.request.use(
    (config) => {
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      // if (ContentType) {
      //   config.headers.ContentType = ContentType;
      //   //console.log(config.headers.ContentType,"originalRequest.headers.ContentType");
        
      // }
      return config;
    },
    (error) => Promise.reject(error)
  );

  apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest._retry
      ) {
        originalRequest._retry = true;
        const newAccessToken = await refreshAccessToken();

        if (ContentType) {
          originalRequest.headers.ContentType = ContentType;
          //console.log(originalRequest.headers.ContentType,"originalRequest.headers.ContentType");
          
        }
        
        if (newAccessToken) {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
          return apiClient(originalRequest);
        }
      }
      return Promise.reject(error);
    }
  );
};

export const getApiClient = () => {
  if (!apiClient) {
    throw new Error(
      "API client is not initialized. Call initializeApiClient first."
    );
  }
  return apiClient;
};

export default loadConfig;
